import { stripStyleUrlFunction } from '@common/html/util/style';
import { EditorEvent } from '@portal-core/project-files/events/editor-event.event';
import { NodeViewBase } from '@portal-core/text-editor/node-views/node-view.base';
import { GetPosForNodeView } from '@portal-core/text-editor/node-views/types/nodeview-get-pos.type';
import { BidiBridge } from '@portal-core/util/bidi-bridge';
import { Node } from 'prosemirror-model';
import { Decoration, EditorView, NodeView } from 'prosemirror-view';

export class ShortcutNodeView extends NodeViewBase implements NodeView {
  private imgDOM: HTMLImageElement;

  /** Opt-in to sync the node when the stylesheet changes. */
  get syncNodeOnStylesheetChanges(): boolean {
    return true;
  }

  constructor(
    node: Node,
    editorView: EditorView,
    getPos: GetPosForNodeView,
    decorations: Decoration[],
    nodeViewBridge: BidiBridge<EditorEvent, EditorEvent>
  ) {
    super(node, editorView, getPos, decorations, nodeViewBridge);

    // Create the contentDOM element and sync the node
    this.contentDOM = this.dom.appendChild(document.createElement('mc-lwe-shortcut-content'));
    this.syncNode();
  }

  syncNode() {
    // Grab the mc styles for the shortcut image
    let imageSrc = stripStyleUrlFunction(getComputedStyle(this.dom).getPropertyValue('--mc-image')) || 'assets/images/editor/flare/shortcut.gif';
    const imagePosition = getComputedStyle(this.dom).getPropertyValue('--mc-image-position') || 'right';
    const imageSpacing = getComputedStyle(this.dom).getPropertyValue('--mc-image-spacing') || '5px';

    if (imagePosition === 'none') {
      imageSrc = null;
    }

    // Update the img element
    if (imageSrc) {
      if (!this.imgDOM) {
        this.imgDOM = document.createElement('img');
        this.imgDOM.setAttribute('contenteditable', 'false');
      }
      this.imgDOM.src = imageSrc;

      if (imagePosition === 'left') {
        this.imgDOM.style.removeProperty('margin-left');
        this.imgDOM.style.setProperty('margin-right', imageSpacing);
        this.dom.prepend(this.imgDOM);
      } else if (imagePosition === 'right') {
        this.imgDOM.style.setProperty('margin-left', imageSpacing);
        this.imgDOM.style.removeProperty('margin-right');
        this.dom.appendChild(this.imgDOM);
      }
    } else {
      this.imgDOM?.remove();
      this.imgDOM = null;
    }
  }
}
